module.exports = __webpack_public_path__ + "static/media/logo-comunidad-lark.5f85fcd0.png";